import React from 'react';

/**
 * Tuile de chiffre clé. Volontairement sobre : la valeur porte le poids
 * visuel, l'icône reste secondaire.
 */
const StatTile = ({ label, value, icon, tone = 'neutral', hint }) => {
  const tones = {
    neutral: 'text-ink-subtle',
    brand: 'text-brand',
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
  };
  return (
    <div className="rounded-card border border-line bg-surface px-4 py-3 shadow-card">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-ink-subtle">{label}</p>
        {icon && <span className={tones[tone] || tones.neutral}>{icon}</span>}
      </div>
      <p className="kpi mt-1 text-4xl font-bold text-ink">{value}</p>
      {hint && <p className="mt-1 text-xs font-medium text-ink-subtle">{hint}</p>}
    </div>
  );
};

export default StatTile;
